module.exports = __webpack_public_path__ + "static/chf-logo-2f1583029bdfe52213cc4a5a330c6a9c.svg";